import React, {Fragment, useEffect, useState} from "react";
import {Button, Form, Spinner} from "react-bootstrap";
import {useForm} from "react-hook-form";
import {
    ACCOUNT_MODE_INDIVIDUAL,
    ACCOUNT_MODE_NORMAL,
    ACCOUNT_MODE_VARIANT_HOSHINO,
    useYupValidationResolver
} from "../../../common";
import * as yup from "yup";
import {adminUpdateAccount} from "../../../api-service/account";
import {toast} from "react-toastify";

const validationSchema = yup.object({});

export function TabAccountComponent({
                                        accountInfo, onSubmit
                                    }) {
    const [isLoading, setLoading] = useState(false);
    const [accountDetail, setAccountDetail] = useState<any>(null);
    const resolver = useYupValidationResolver(validationSchema);
    const {
        register,
        control,
        handleSubmit,
        setValue,
        reset,
        getValues,
        watch,
        clearErrors,
        formState: {isSubmitting, isDirty, errors, isSubmitted}
    } = useForm({
        resolver: resolver,
        defaultValues: {
            useFaceRecognition: false,
            useAccessControl: false,
            useAttendanceApplication: false,
            disableCardSyncNotification: false,
            accountMode: ACCOUNT_MODE_NORMAL,
            accountModeVariant: ACCOUNT_MODE_VARIANT_HOSHINO,
        },
        mode: "onBlur",
        reValidateMode: "onChange"

    });

    const watchMode = watch("accountMode");

    useEffect(() => {
        console.log(accountInfo);
        let detail = accountInfo.detail;
        setAccountDetail(detail);
        reset({
            useFaceRecognition: detail?.useFaceRecognition ?? false,
            useAccessControl: detail?.useAccessControl ?? false,
            useAttendanceApplication : detail?.useAttendanceApplication ?? false,
            disableCardSyncNotification : detail?.disableCardSyncNotification ?? false,
            accountMode: detail?.AccountMode ?? ACCOUNT_MODE_NORMAL,
            accountModeVariant: detail?.AccountModeVariant ?? ACCOUNT_MODE_VARIANT_HOSHINO,
        })
    }, [accountInfo,]);
    const submitFormData = async (data) => {
        const requestData = {
            ...data,
            AccountId: accountDetail.AccountId,
            AccountModeVariant: data.accountMode === ACCOUNT_MODE_INDIVIDUAL ? data.accountModeVariant : null,
        }
        setLoading(true);
        await adminUpdateAccount(requestData).then((response: any) => {
            console.log(response);
            setLoading(false);
            toast.success("保存されました。");
            onSubmit();
        }).catch(err => {
            toast.error("保存処理に失敗しました。再度お試しください。");
            setLoading(false);
        });
    }

    return (
        <Fragment>
            <div className="tab-setting-account bg-white p-3">
                <Form onSubmit={handleSubmit(submitFormData)}>

                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            取引先ID
                        </Form.Label>
                        <div className="d-flex w-100 align-items-center">
                            <p className={"mb-0"}>{accountDetail?.AccountId}</p>
                        </div>
                    </div>
                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            取引先名
                        </Form.Label>
                        <div className="d-flex w-100 align-items-center">
                            <p className={"mb-0"}>{accountDetail?.AccountName}</p>

                        </div>
                    </div>
                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            顔認証
                        </Form.Label>
                        <div className="d-flex align-items-center w-100">
                            <Form.Check className="mb-0 float-start">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    {...register(`useFaceRecognition`)}
                                />
                            </Form.Check>

                        </div>
                    </div>
                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            入退館連携
                        </Form.Label>
                        <div className="d-flex align-items-center w-100">
                            <Form.Check className="mb-0 float-start">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    {...register(`useAccessControl`)}
                                />
                            </Form.Check>


                        </div>
                    </div>

                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            勤怠申請表示
                        </Form.Label>
                        <div className="d-flex align-items-center w-100">
                            <Form.Check className="mb-0 float-start">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    {...register(`useAttendanceApplication`)}
                                />
                            </Form.Check>
                        </div>
                    </div>

                    <div className="d-flex pt-3 form-input-account">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            IDm同期通知しない
                        </Form.Label>
                        <div className="d-flex align-items-center w-100">
                            <Form.Check className="mb-0 float-start">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    {...register(`disableCardSyncNotification`)}
                                />
                            </Form.Check>
                        </div>
                    </div>

                    <div className="d-flex pt-3 form-input-account radio-group">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0" style={{minWidth: "120px"}}>
                            モード
                        </Form.Label>
                        <div className="d-flex align-items-start flex-column gap-2 flex-grow-1">
                            <div className="d-flex align-items-center gap-2">
                                <Form.Check
                                    inline
                                    type="radio"
                                    id="mode-normal"
                                    label="通常"
                                    value={ACCOUNT_MODE_NORMAL}
                                    {...register(`accountMode`)}
                                />
                                <p className="text-highlight small mb-0">
                                    ※基本的には「通常」を選択してください。
                                </p>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <Form.Check
                                    inline
                                    type="radio"
                                    id="mode-individual"
                                    label="個別"
                                    value={ACCOUNT_MODE_INDIVIDUAL}
                                    {...register(`accountMode`)}
                                />
                                <Form.Select
                                    aria-label="モード種類"
                                    size="sm"
                                    className="w-auto"
                                    disabled={watchMode !== ACCOUNT_MODE_INDIVIDUAL}
                                    {...register(`accountModeVariant`)}
                                >
                                    <option value={ACCOUNT_MODE_VARIANT_HOSHINO}>星野モード</option>
                                </Form.Select>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex pt-3 justify-content-center">
                        {
                            isLoading ?
                                <Button size={'sm'} className="button-search" disabled>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    保存...
                                </Button>
                                :
                                <Button className="btn-detail btn btn-primary btn-sm" type={"submit"}>
                                    保存
                                </Button>
                        }
                    </div>

                </Form>
            </div>
        </Fragment>
    )

}